/* unplugin-vue-components disabled */import { render } from "./appointment.vue?vue&type=template&id=316c600d&scoped=true&ts=true"
import script from "./appointment.vue?vue&type=script&lang=ts"
export * from "./appointment.vue?vue&type=script&lang=ts"

import "./appointment.vue?vue&type=style&index=0&id=316c600d&scoped=true&lang=scss"

import exportComponent from "/Users/beixinyuan/Documents/www/newParty1/party-pc/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-316c600d"]])

export default __exports__